import { COUNTRIES } from "@/constants/countries";
import { PHONE_TYPES } from "@/constants/phone-types";
import { PhoneTypes } from "@/enums/types";
import type { Person } from "@/repositories/people/types";
import type { CountryCode, CountryNumber } from "@/types/countries";

/**
 * Constructs a phone number by combining a country code and a phone number.
 *
 * @param number - The phone number as a string.
 * @param code - The country code as a `CountryCode`.
 * @returns The full phone number as a string, including the country dial code.
 */
export function buildPhoneFromCodeAndNumber(number: string, code: CountryCode) {
  return COUNTRIES[code]?.dialCode + number;
}

export function buildPhoneFromCodeNumAndNumber(number: string, code: CountryNumber) {
  return code + number;
}

/**
 * Maps an array of phone objects to a format suitable for signup.
 *
 * @param phones - An array of phone objects, each containing a `value` (phone number) and a `code` (country code).
 * @returns An array of phone objects formatted for signup, where the first phone is marked as active and all phones are prefixed with their respective country dial codes.
 */
export function mapPhonesForSignup(phones: { value: string; code: CountryCode }[]) {
  return phones.map((phone, index) => {
    return {
      // In the legacy app the `active` property is set to `true` just for the first phone
      active: index === 0,
      type: PhoneTypes.MOBILE,
      value: buildPhoneFromCodeAndNumber(phone.value, phone.code),
    };
  });
}

export function isPhoneContactType(type: string | null | undefined): boolean {
  for (const phoneType of Object.values(PHONE_TYPES)) {
    if (type === phoneType.value) {
      return true;
    }
  }

  return false;
}

export function hasExcludeMandatoryPermission(
  person: Pick<Partial<Person>, "permissions"> | null | undefined
): boolean {
  return person?.permissions?.excludeMandatory === true;
}
